import React, { useRef, useState } from "react";
import style from "../common.module.scss";
import { useClickOutside } from "../../../hooks/useClickOutside";
import CloseIconNew from "../../shared/icons/CloseIconNew";
import CustomInput from "../../custom/custom-input/CustomInput";
import CustomButton from "../../custom/custom-button/CustomButton";
import { User } from "../../../services";
import { toast } from "react-toastify";
import {t} from "i18next";

const ModalAddTransportCompany = ({ setShowModal, ListPartners, user }) => {
  const modalRef = useRef(null);

  const [organizationName, setOrganizationName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errorName, setErrorName] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useClickOutside(modalRef, () => {
    setShowModal(false);
  });

  const handleInvite = () => {
    if (user && !user.permissions?.includes("partner_add")) {
      toast.info("Упс! Кажется, у вас нет доступа к этой функции. Позвоните в отдел продаж: +7 775 007 53 98", {
        autoClose: 10000
      });
      return;
    }

    if (!organizationName || !email) {
      !organizationName && setErrorName("Заполните данные");
      !email && setErrorEmail("Заполните данные");
      return;
    }

    setErrorName("");
    setErrorEmail("");
    setLoading(true);

    User.addPartner({
      companyName: organizationName,
      email: email,
      phoneNumber: phoneNumber,
    })
      .then(() => {
        setShowModal(false);
        setLoading(false);
        toast.success("Приглашение успешно отправлено");
        ListPartners();
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.error("Ошибка при отправке данных. Попробуйте еще раз.");
      });
  };

  return (
    <div className={style.modalOverlay}>
      <div ref={modalRef} className={style.modalContent}>
        <h4>
          {t("partners.addCompanyModal")}
          <CloseIconNew onClick={() => setShowModal(false)} style={{ cursor: "pointer" }} />
        </h4>
        <CustomInput
          placeholder={t("partners.organizationName")}
          labelText={t("partners.organizationName")}
          errorText={errorName}
          inputType="text"
          value={organizationName}
          onChangeValue={setOrganizationName}
        />
        <CustomInput
          placeholder={t("partners.email")}
          labelText="E-mail"
          errorText={errorEmail}
          inputType="text"
          value={email}
          onChangeValue={setEmail}
        />
        <CustomInput
          placeholder={t("partners.phoneNumberPlaceholder")}
          labelText={t("partners.phoneNumber")}
          inputType="text"
          value={phoneNumber}
          onChangeValue={setPhoneNumber}
          isPhone
        />
        <CustomButton text={t("partners.inviteButton")} onClick={handleInvite} isFall isLoading={loading} />
      </div>
    </div>
  );
};

export default ModalAddTransportCompany;
